import { useLingui } from '@lingui/react';
import { AlertCircle } from 'lucide-react';
import { StatusBadge } from '@/components/ui/status-badge';
import { DUNNING_BLOCKER_STATUS } from './stageBadge';

interface Props {
  reason: string;
}

/** Why the next reminder cannot go out: icon, tone and label from one map. */
export function DunningBlockerBadge({ reason }: Props) {
  const { i18n } = useLingui();
  const status = DUNNING_BLOCKER_STATUS[reason];
  if (!status) {
    return <StatusBadge tone="warning" icon={AlertCircle} label={reason} />;
  }
  return <StatusBadge tone={status.tone} icon={status.icon} label={i18n._(status.label)} />;
}
